import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { GoogleBigQueryObjectDataset } from 'app/model/dataset/google-bigquery.dataset';
import { TabularCopySource } from './tabular-type.copysource';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.googleBigQuery.copySourceType,
    disabled: __IS_FABRIC_DPE__,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(GoogleBigQueryObjectDataset) }
})
export class GoogleBigQueryCopySource extends TabularCopySource {
}
